import { BillIcon, CashIcon, PettyCashBudgetIcon } from '@razorpay/blade/components';
import ComponentContainer from 'components/PayDetails/components/generics/ComponentContainer';
import ComponentHeader from 'components/PayDetails/components/generics/ComponentHeader';
import ComponentSection from 'components/PayDetails/components/generics/ComponentSection';
import ComponentSectionItem from 'components/PayDetails/components/generics/ComponentSectionItem';
import { SalaryStructureComponent } from 'components/SalaryStructure/types';
import React from 'react';
import StructureComponentTable from './StructureComponentTable';

const PreviewSalaryStructure = ({
  earningComponents,
  variableComponents,
  nonPayableBenefitsComponents,
}: {
  earningComponents: SalaryStructureComponent[];
  variableComponents: SalaryStructureComponent[];
  nonPayableBenefitsComponents: SalaryStructureComponent[];
}) => {
  return (
    <ComponentContainer gap="spacing.7">
      {earningComponents.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<CashIcon size="medium" color="surface.icon.onSea.onSubtle" />}
            iconBackground={'surface.background.sea.subtle'}
            title={'Fixed'}
            description={'Monthly earning component'}
          />
          <ComponentSectionItem>
            <StructureComponentTable components={earningComponents} />
          </ComponentSectionItem>
        </ComponentSection>
      )}
      {variableComponents.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<PettyCashBudgetIcon size="medium" color="surface.icon.primary.normal" />}
            iconBackground={'surface.background.sea.subtle'}
            title={'Variable'}
            description={'Variable component based on performance, not part of monthly salary'}
          />
          <ComponentSectionItem>
            <StructureComponentTable components={variableComponents} />
          </ComponentSectionItem>
        </ComponentSection>
      )}
      {nonPayableBenefitsComponents.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<BillIcon size="medium" color="surface.icon.gray.normal" />}
            iconBackground={'surface.background.gray.intense'}
            title={'Other CTC component'}
            description={'Components part of CTC but not directly payable to the employee'}
          />
          <ComponentSectionItem>
            <StructureComponentTable components={nonPayableBenefitsComponents} />
          </ComponentSectionItem>
        </ComponentSection>
      )}
    </ComponentContainer>
  );
};

export default PreviewSalaryStructure;
